import React from 'react'

import Header from '../../components/header/index.js'
import Footer from '../../components/footer/index.js'
import IntegrationLayerRegisterSystem from '../../components/integrationLayerRegisterSystem/index.js'

const RegisterEntityIL = () => {

    return (
        <div>
            <Header />

            <IntegrationLayerRegisterSystem />

            <Footer />
        </div>
    );
}

export default RegisterEntityIL;